import assert from 'minimalistic-assert'

export const createGetBalanceForAddress = ({ asset, server }) => {
  assert(asset, 'asset is required')
  assert(server, 'server is required')
  return async (address) => {
    const balance = await server.getBalanceProxied(address)
    if (typeof balance === 'string') {
      // hex-response from eth_getBalance node
      return asset.currency.baseUnit(balance)
    }

    if (balance && typeof balance === 'object' && typeof balance.confirmed?.value === 'string') {
      // Magnifier/Clarity reponse
      return asset.currency.baseUnit(balance.confirmed.value)
    }

    throw new Error('unable to parse server response for getBalance')
  }
}
